import type { ComponentType, ReactNode } from "react";
import { Component } from "react";

import autobind from "autobind-decorator";

import { swSettings } from "app/common/services/swSettings";
import { SwTrack } from "app/services/SwTrack";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import * as utils from "./trackinkUtils";

export const FILTER_CHANGED_NOTIFICATION_WIDTH = 265;

export interface IFilterBaseProps {
    height?: number | string;
    width?: number | string;
    disabled?: boolean;
    onToggle?: (isOpen: boolean, isOutsideClick?: boolean) => void;
    itemWrapper?: ComponentType<any>;
    appendTo?: string;
    dropdownPopupPlacement?: string;
    presentNotificationIndicator?: boolean; //blue dot indicator that displayed when filter has change from default selection
    presentNotificationTooltipKey?: string;
    children?: ReactNode;
}

export interface IFiltersBaseState {
    isSideBarOpen: boolean;
}

export class FiltersBase<P = {}, S extends IFiltersBaseState = IFiltersBaseState> extends Component<P, S> {
    protected services;

    constructor(props: P) {
        super(props);
        this.services = {
            swSettings,
            swNavigator: proNavigator,
            track: SwTrack,
        };
    }

    @autobind
    protected toggleSidebar() {
        const isSideBarOpen = !this.state.isSideBarOpen;
        this.setState({
            isSideBarOpen,
        });
    }

    @autobind
    protected onSideBarToggle(isOpen: boolean) {
        utils.trackSideBar(isOpen);
        this.setState({
            isSideBarOpen: isOpen,
        });
    }
    protected setStateAsync<K extends keyof S>(newState: Pick<S, K> | S | null) {
        return new Promise<void>((resolve) => {
            this.setState(newState, resolve);
        });
    }

    @autobind
    protected trackFilterDropDownStatus(eventName: string) {
        return (isOpen: boolean) => {
            this.services.track.all.trackEvent("Drop down", isOpen ? "open" : "close", eventName);
        };
    }

    @autobind
    protected trackFilterValue(eventName: string, eventValue?: number) {
        this.services.track.all.trackEvent("Drop Down", "click", eventName, eventValue);
    }
}
